module.exports = __webpack_public_path__ + "img/Chemithon.5f979a8a.png";